import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Only attach for your own backend
        if (req.url.startsWith(`${environment.api}`)) {
            const cloned = req.clone({ withCredentials: true });
            return next.handle(cloned);
        }
        return next.handle(req);
    }
}